// Design system MBM · Fase 1 (cerrado)
// Regla dura: rojo pequeño solo sobre blanco. Rojo NUNCA en avisos (avisos = ámbar).
export const colors = {
  accion: '#E40C0C', // 1 CTA rojo por pantalla, nunca alertas
  tinta: '#1D1D1D',
  papel: '#FFFFFF',
  superficie: '#F3F3F3',
  borde: '#E2E2E2',
  sec: '#4E4E4E',
  humano: '#2F6B4F', // siempre con ícono de asesor
  aviso: '#B45309', // todo aviso / error / contador
};

export const fonts = {
  display: "'Fraunces', Georgia, serif",
  body: "'Source Sans 3', system-ui, sans-serif",
};

// Contraste medido (WCAG 2.x, luminancia relativa)
export const contraste = [
  ['accion/papel', '4.82:1', 'AA texto grande · UI'],
  ['accion/superficie', '4.34:1', 'PROHIBIDO rojo pequeño sobre #F3F3F3'],
  ['tinta/papel', '16.86:1', 'AAA'],
  ['tinta/superficie', '15.19:1', 'AAA'],
  ['sec/papel', '8.32:1', 'AAA'],
  ['sec/superficie', '7.50:1', 'AA'],
  ['humano/papel', '6.29:1', 'AA'],
  ['aviso/papel', '5.02:1', 'AA'],
  ['aviso/superficie', '4.53:1', 'AA'],
  ['papel/accion', '4.82:1', 'AA texto grande (CTA)'],
  ['papel/humano', '6.29:1', 'AA'],
];

export const decColor = {
  info: '#4E4E4E', // gris
  pasa: '#2F6B4F', // verde
  aviso: '#B45309', // ámbar
  escala: '#2F6B4F', // humano · nunca rojo
};
